import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';

export * from '../styles';

export const LossProgressBar = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== '$successPercentage',
})<{ $successPercentage: number }>(({ theme, $successPercentage }) => ({
  height: 8,
  borderRadius: 6,
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.08)'
      : 'rgba(0, 0, 0, 0.06)',
  border: `1px solid ${
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.06)'
      : 'rgba(0, 0, 0, 0.04)'
  }`,
  '& .MuiLinearProgress-bar': {
    background:
      $successPercentage > 0
        ? 'linear-gradient(90deg, #22C55E 0%, #10B981 100%)'
        : 'linear-gradient(90deg, #EF4444 0%, #DC2626 100%)',
    boxShadow:
      $successPercentage > 0
        ? '0 0 12px rgba(34, 197, 94, 0.45)'
        : '0 0 12px rgba(239, 68, 68, 0.45)',
    borderRadius: 6,
    transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
  },
}));
